import { AiFillHtml5 } from 'react-icons/ai';
import {
  SiCss3,
  SiJavascript,
  SiRedux,
  SiSass,
  SiTypescript,
} from 'react-icons/si';
import { TbBrandNextjs } from 'react-icons/tb';
import { FaPhp, FaReact } from 'react-icons/fa';
import { IoLogoCss3, IoLogoJavascript } from 'react-icons/io';
import { IoLogoFirebase } from 'react-icons/io5';
import { RiTailwindCssFill } from 'react-icons/ri';
import { SiMantine } from 'react-icons/si';

export const GSAPIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='currentColor'
    viewBox='0 0 24 24'
  >
    <path d='m7.83,11.76h0s-.26,1.15-.26,1.15c-.01.06-.08.11-.15.11h-.32s-.04.02-.05.04c-.29.99-.69,1.68-1.21,2.09-.45.35-1,.51-1.73.51-.66,0-1.1-.21-1.48-.63-.5-.55-.7-1.46-.58-2.55.22-2.05,1.29-4.12,3.34-4.12.62,0,1.11.19,1.45.57.36.41.54,1.02.54,1.82,0,.07-.06.13-.13.13h-1.5c-.05,0-.1-.05-.1-.1-.01-.55-.18-.82-.5-.82-.58,0-.91.78-1.09,1.21-.25.6-.38,1.26-.35,1.92.01.3.06.73.35.91.26.16.62.05.84-.12.22-.17.4-.48.47-.75.01-.04.01-.07,0-.08-.01-.01-.04-.02-.06-.02h-.39s-.08-.02-.11-.05c-.02-.02-.03-.06-.02-.09l.26-1.14c.01-.06.07-.1.13-.11h0s2.53,0,2.53,0c0,0,.01,0,.02,0,.07,0,.11.07.11.14h0Z' />
    <path d='m12.18,10.45c0,.07-.06.13-.13.13h-1.38c-.09,0-.17-.07-.17-.16,0-.4-.14-.6-.42-.6s-.47.18-.47.48c0,.34.19.65.74,1.18.72.68,1.01,1.28,1,2.08-.02,1.29-.9,2.12-2.23,2.12-.68,0-1.2-.18-1.54-.54-.35-.36-.51-.9-.48-1.59,0-.07.06-.13.13-.13h1.43s.08.02.1.05c.02.03.03.06.03.09-.02.25.03.43.13.54.06.07.15.1.26.1.26,0,.42-.19.42-.51,0-.28-.08-.53-.57-1.03-.63-.61-1.19-1.24-1.17-2.23.01-.58.24-1.1.64-1.48.43-.4,1.01-.61,1.69-.61.68,0,1.2.2,1.53.58.32.36.47.88.46,1.54h0Z' />
    <path d='m16.47,15.43v-6.84c.01-.07-.05-.13-.12-.13,0,0,0,0,0,0h-2.14c-.07,0-.1.06-.12.1l-3.1,6.82h0s0,0,0,0c-.03.08.03.17.12.17h1.5c.08,0,.13-.02.16-.08l.3-.71c.04-.09.04-.1.15-.1h1.43c.1,0,.1,0,.1.1l-.03.66c0,.07.06.13.13.13,0,0,0,0,0,0h1.51s.07-.02.1-.04c.02-.02.03-.06.03-.09Zm-2.65-2.28s-.02,0-.03,0c-.02,0-.03-.02-.03-.04,0,0,0,0,0,0,0-.01,0-.02.01-.04l1.07-2.65s.02-.05.03-.08c.02-.04.04-.04.05-.01,0,.02-.12,2.72-.12,2.72-.01.1-.01.11-.11.11h-.86s0-.01,0-.01h0s0,0,0,0Z' />
    <path d='m19.51,8.46h-1.14c-.06,0-.13.03-.14.1l-1.58,6.86s0,.06.02.09c.03.03.07.05.11.05h1.42c.08,0,.13-.04.14-.1,0,0,.17-.78.17-.78.01-.06,0-.11-.06-.14-.03-.01-.05-.03-.08-.04l-.25-.13-.24-.13-.09-.05s-.03-.02-.02-.04c0-.03.02-.05.05-.05h.78c.23,0,.47-.01.69-.05,1.61-.3,2.68-1.59,2.71-3.34.03-1.5-.81-2.26-2.48-2.26,0,0,0,0,0,0Zm-.39,4.08h-.03c-.07,0-.08,0-.08,0,0,0,.45-1.98.45-1.98.01-.06.01-.09-.02-.11-.05-.02-.7-.37-.7-.37-.02,0-.03-.02-.02-.04,0-.03.02-.05.05-.05h1.04c.32,0,.5.3.49.79-.01.85-.42,1.74-1.17,1.77h0Z' />
  </svg>
);

export const projects = [
  {
    name: 'Splyt Clone',
    stack: [
      { title: 'React', icon: <FaReact /> },
      { title: 'TypeScript', icon: <SiTypescript /> },
      { title: 'Tailwind CSS', icon: <RiTailwindCssFill /> },
      { title: 'GSAP', icon: <GSAPIcon /> },
    ],
    info: 'Splyt Clone is a clone of the Splyt app, which was built using React, TypeScript, Tailwind CSS, and GSAP. It is fully responsive.',
    imgUrls: [
      '/images/spylt-1.png',
      '/images/spylt-2.png',
      '/images/spylt-3.png',
      '/images/spylt-4.png',
      '/images/spylt-5.png',
    ],
    id: '1',
    url: 'https://fojo-spylt-clone.netlify.app/',
    date: 'December, 2025',
  },
  {
    name: 'Tech Agency (Grind)',
    stack: [
      { title: 'Next.Js', icon: <TbBrandNextjs /> },
      { title: 'SCSS', icon: <SiSass /> },
    ],
    info: 'This project is a website for a dummy tech agency (Grind), which have some features like page animations, lazy loading, intersection observers, pointer movements animations, infinite scrolling,  etc. \nThis project is responsive on all devices.',
    imgUrls: [
      '/images/grind1.png',
      '/images/grind2.png',
      '/images/grind4.png',
      '/images/grind5.png',
      '/images/grind6.png',
      '/images/grind7.png',
    ],
    id: 'b45d',
    url: 'https://grindagency.netlify.app',
    date: 'March, 2024',
  },
  {
    name: 'Social Publishing Platform',
    stack: [
      { title: 'React', icon: <FaReact /> },
      { title: 'Redux', icon: <SiRedux /> },
      { title: 'Typescript', icon: <SiTypescript /> },
      { title: 'SCSS', icon: <SiSass /> },
      { title: 'Firebase', icon: <IoLogoFirebase /> },
    ],
    info: 'Devie is a social publising platform project, where users can register on, and publish posts on various topics. \nIt has a rich text editor, which was built completely by me, making basic text formatting possible. It also has an infinite nested comment system. \nThis project is responsive.',
    imgUrls: [
      '/images/devie_home.png',
      '/images/devie_dash.png',
      '/images/devie_login.png',
      '/images/devie_editor.png',
      '/images/devie_coms.png',
      '/images/devie_about.png',
      '/images/devie_post.png',
    ],
    id: 'a',
    url: 'https://devie.netlify.app/',
    date: 'December, 2023',
  },
  {
    name: '3D Portfolio',
    stack: [
      { title: 'Next.Js', icon: <TbBrandNextjs /> },
      { title: 'SCSS', icon: <SiSass /> },
    ],
    info: 'This is a dummy 3D portfolio website in a book form. Naviagtion from one page to the other is also in the form of a book. \nThis projects utilizes the concept of 3D CSS. It is also responsive.',
    imgUrls: ['/images/book1.png', '/images/book2.png', '/images/book3.png'],
    id: 'a1g',
    url: 'https://johnbook.netlify.app',
    date: 'February, 2024',
  },
  {
    name: 'MTN NG Home Page Clone',
    stack: [
      { title: 'React', icon: <FaReact /> },
      { title: 'Typescript', icon: <SiTypescript /> },
      { title: 'SCSS', icon: <SiSass /> },
    ],
    info: 'I cloned the home page of MTN NG (as at December 2023), with some modifications to the scroll bar, navbar dropdown, and addition of dark mode and intersection observer. \nIt is a also responsive.',
    imgUrls: ['/images/mtn_proj1.jpg', '/images/mtn_proj2.png'],
    id: 'ab',
    url: 'https://mtnnghomemod.netlify.app/',
    date: 'January, 2024',
  },
];

export const exps = [
  {
    date: 'mar 2023 - dec 2023',
    role: 'React Developer (full-time)',
    org: 'Dowell Research',
    stack: [
      { name: 'JavaScript', Icon: SiJavascript },
      { name: 'React', Icon: FaReact },
      { name: 'Redux', Icon: SiRedux },
      { name: 'CSS', Icon: SiCss3 },
    ],
    duties: [
      `Optimized application performance by 25% using lazy loading,
preventing unnecessary component re-renders, implementing
pagination, and optimizing API calls. This reduced the app startup time
from an average of 8 seconds to 3 seconds.`,
      `Enhanced accessibility and expanded user base by ensuring mobilefriendliness and improved responsiveness across various devices, leading
to increase in user adoption`,
      `Caused a 30% increase in user satisfaction and productivity with the
addition of a folder organization feature, enabling users to efficiently
organize documents and templates within the application.`,
      `Improved user experience for beginners by adding descriptive tooltips to
buttons, which resulted in a 15% increase in user retention.
`,
    ],
  },
  {
    date: 'Jan 2024',
    role: 'Frontend developer (contract)',
    org: 'Embodiment Healthcare',
    stack: [
      { name: 'React', Icon: FaReact },
      { name: 'TypeScript', Icon: SiTypescript },
      { name: 'SCSS', Icon: SiSass },
    ],
    duties: [
      `Successfully implemented the company's design system to
ensure website consistency with the provided template while
maintaining a clear brand identity.`,
      `Optimized the website for a fully responsive experience across
all devices, resulting in improved accessibility and user
experience.`,
    ],
  },
  {
    date: 'sept 2024 - jan 2025',
    role: 'Frontend Developer (contract)',
    org: 'Embodilearn',
    stack: [
      { name: 'React', Icon: FaReact },
      { name: 'Redux', Icon: SiRedux },
      { name: 'Tailwind CSS', Icon: RiTailwindCssFill },
      { name: 'Mantine UI', Icon: SiMantine },
      { name: 'TypeScript', Icon: SiTypescript },
      {
        name: 'NextJS',
        Icon: TbBrandNextjs,
      },
    ],
    duties: [
      `Developed and maintained pixel-perfect frontend interfaces for
admin, user, and public-facing platforms, translating UI/UX
designs into highly responsive and visually consistent web
applications.`,
      `Ensured code maintainability and seamless collaboration by
leveraging Git for version control, implementing effective
branching strategies, and maintaining clear commit histories.`,
      `Upheld high-quality standards by strictly adhering to established
coding conventions and best practices, contributing to smoother
code reviews and enhanced team productivity.`,
      `Diagnosed and resolved bugs proactively across multiple
environments, consistently reducing turnaround time on critical
issues and improving application stability.
`,
    ],
  },
  {
    date: 'nov 2024 - mar 2025',
    role: 'Frontend Developer (contract)',
    org: 'Software Business Solutions Consulting(SBSC)',
    stack: [
      { name: 'JavaScript', Icon: SiJavascript },
      { name: 'React', Icon: FaReact },
      { name: 'Redux', Icon: SiRedux },
      { name: 'Tailwind CSS', Icon: RiTailwindCssFill },
      { name: 'Mantine UI', Icon: SiMantine },
      { name: 'TypeScript', Icon: SiTypescript },
    ],
    duties: [
      `Spearheaded the redesign and development of both admin and client-
facing web interfaces for a fintech platform, resulting in a more intuitive UI and contributing to a 40% drop in user-reported issues.`,
      `Collaborated on multiple client projects, integrating reusable component
libraries and streamlining development workflows, which cut delivery
timelines by an average of 20%.`,
      `Delivered robust frontend solutions for two enterprise resource planning
(ERP) systems, improving data visualization accuracy and reducing user
navigation time by implementing advanced filtering and modular
dashboards.`,
      `Guided and mentored 3 interns, conducting code reviews and
knowledge-sharing sessions that improved their code quality and
accelerated onboarding by two weeks on average.
`,
    ],
  },
  {
    date: 'mar 2025 - mar 2026',
    role: 'Web Developer',
    org: 'Scandiweb',
    stack: [
      { name: 'React', Icon: FaReact },
      { name: 'TypeScript', Icon: SiTypescript },
      { name: 'CSS', Icon: SiCss3 },
      { name: 'Next.Js', Icon: TbBrandNextjs },
      { name: 'Tailwind CSS', Icon: RiTailwindCssFill },
      { name: 'Redux', Icon: SiRedux },
      { name: 'PHP', Icon: FaPhp },
    ],
    duties: [
      `Built and maintained new features for a Magento-based hosting platform serving multiple e-commerce clients.`,
      `Improved maintainability and refactoring legacy components.`,
      `Diagnosed and resolved bugs across multiple repositories within the Readymage ecosystem.`,
      `Collaborated with cross-functional teams to implement scalable frontend and backed enhancements.`,
      `Collaborated in code review and followed Git workflows aligned with team standards.`,
      `Converted Figma designs into responsive, pixel-perfect web interfaces using Next.js, Storyblok CMS, and Tailwind CSS, ensuring a seamless user experience across devices.`,
    ],
  },
];

export const stacks = [
  { Icon: AiFillHtml5, title: 'HTML5', id: 'html' },
  { Icon: IoLogoCss3, title: 'CSS3', id: 'css' },
  { Icon: IoLogoJavascript, title: 'JavaScript', id: 'js' },
  { Icon: SiTypescript, title: 'TypeScript', id: 'ts' },
  { Icon: FaReact, title: 'React', id: 'react' },
  { Icon: SiRedux, title: 'Redux', id: 'redux' },
  { Icon: TbBrandNextjs, title: 'Next.Js', id: 'next' },
  { Icon: SiSass, title: 'SCSS', id: 'sass' },
  { Icon: RiTailwindCssFill, title: 'Tailwind', id: 'tailwind' },
  { Icon: SiMantine, title: 'Mantine UI', id: 'mantine' },
  { Icon: IoLogoFirebase, title: 'Firebase', id: 'firebase' },
  { Icon: GSAPIcon, title: 'GSAP', id: 'gsap' },
];
